var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36434e",
    d: "m9,18c4.9706,0 9,-4.0294 9,-9c0,-4.97056 -4.0294,-9 -9,-9c-4.97056,0 -9,4.02944 -9,9c0,4.9706 4.02944,9 9,9zm0.86461,-4l0,-7.182l-1.729,0l0,7.182l1.729,0zm0.16799,-8.855c0.0607,-0.13067 0.091,-0.27067 0.091,-0.42c0,-0.154 -0.0303,-0.29867 -0.091,-0.434c-0.06066,-0.13533 -0.14232,-0.252 -0.24499,-0.35c-0.098,-0.098 -0.21467,-0.175 -0.35,-0.231c-0.13533,-0.06067 -0.28,-0.091 -0.434,-0.091c-0.14933,0 -0.29167,0.03033 -0.427,0.091c-0.13067,0.056 -0.245,0.133 -0.343,0.231c-0.098,0.098 -0.17733,0.21467 -0.238,0.35c-0.056,0.13533 -0.084,0.28 -0.084,0.434c0,0.14933 0.028,0.28933 0.084,0.42c0.06067,0.13067 0.14,0.245 0.238,0.343c0.098,0.098 0.21233,0.17733 0.343,0.238c0.13533,0.056 0.27767,0.084 0.427,0.084c0.154,0 0.29867,-0.028 0.434,-0.084c0.13533,-0.06067 0.252,-0.14 0.35,-0.238c0.10267,-0.098 0.18433,-0.21233 0.24499,-0.343z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIconDark);
export default __webpack_public_path__ + "static/media/info-circle-icon-dark.802510afcd9adb046a3848ff9b9cc980.svg";
export { ForwardRef as ReactComponent };